import React/*, {useState}*/ from 'react';
//import { findDOMNode } from 'react-dom';
import {putApi, consoleLog} from '../../../utils/functions';
import {UserContext} from '../../../utils/usercontext';

import ReactPlayer from 'react-player';
import screenfull from 'screenfull';
import './video.css';
import './audioplayer.css';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import { ReactComponent as PlayButton} from './images/play.svg';
import { ReactComponent as StopButton} from './images/stop.svg';
import { ReactComponent as VolumeButton0} from './images/volume-0.svg';
import { ReactComponent as VolumeButton50} from './images/volume-50.svg';
import { ReactComponent as VolumeButton100} from './images/volume-100.svg';
import { ReactComponent as TheatreOnButton} from './images/airplay-on.svg';
import { ReactComponent as FullscreenOnButton} from './images/fullscreen.svg';
import { ReactComponent as CDN} from './images/quality-100.svg';
import { ReactComponent as Settings} from './images/settings.svg';



/*
  Video Status
  0 - Stopped
  1 - Loading
  2 - Playing
  3 - Buffering

  Video controls
  service={serviceID} between service || url will determine if the stream is live!
  url={url}
  controls={true|false}
  muted={true|false}
  autoPlay={true|false}
*/

class VideoPlayer extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    //consoleLog(this.props.select);
    this.state = {

      service: props.service || undefined,
      url: props.url?props.url.replaceAll(' ','%20'):undefined,
      //controls: props.controls,
      
      autoPlay: props.autoPlay,

			//url: null,
			playing: false,
			//volume: 1,
			//muted: this.iOSversion(),
			
      controls: {
        show: props.controls,
        visible: false,
      },

      time: {
        position: "00:00",
			  duration: '00:00',
			  percent: 0,
      },

      volume: {
        show: false,
        muted: props.muted?this.iOSversion():false,
        volume: 1
      },

      source: {
        show: false,
        selected: 0
      },

      locations: {
        show: false,
        selected: -1,
        servers: [],
      },

      resolution: {},

      resolutions: [],

      //status: 0,
      //uid: this.props.uid,
      //controls: false,
      //volume: 100,
      //volumeshow: false,
      //mute: false,
      //settings: false, // video quality
      //height: this.props.height, // do we need this?
      //stream: 0,
      //stream_url: '',
      //showHelp: true,
      //meta: {},
      //VideoAudio: null
      //cdn: false,
      //servers: [],

      /*video: {
        service: 0,
        server: 0,
      }*/
    };
    this.playVideo = this.playVideo.bind(this);
    //this.retryVideo = this.retryVideo.bind(this);
    //this.stopVideo = this.stopVideo.bind(this);
    this.showControls = this.showControls.bind(this);
    this.hideControls = this.hideControls.bind(this);
    this.showVolume = this.showVolume.bind(this);
    this.hideVolume = this.hideVolume.bind(this);
    this.setVolume = this.setVolume.bind(this);
    this.muteVolume = this.muteVolume.bind(this);
    this.fullscreen = this.fullscreen.bind(this);
    this.settings = this.settings.bind(this);
    this.cdn = this.cdn.bind(this);
    this.selectStream = this.selectStream.bind(this);
    this.selectServer = this.selectServer.bind(this);
    this.videoHelp = this.videoHelp.bind(this);
    this.progress = this.progress.bind(this);
    this.convertTime = this.convertTime.bind(this);
    this.position = this.position.bind(this);
    this.mute = this.mute.bind(this);
    
  }

  iOSversion() {
    if((navigator.vendor !== null && navigator.vendor.match(/Apple Computer, Inc./) && navigator.userAgent.match(/iPhone/i)) || (navigator.userAgent.match(/iPod/i))) {
      return true;
    } else if (navigator.vendor !== null && navigator.vendor.match(/Apple Computer, Inc./) && navigator.userAgent.match(/iPad/i)) {
      return true;
    } else if (navigator.vendor !== null && navigator.vendor.match(/Apple Computer, Inc./) && navigator.userAgent.indexOf('Safari') !== -1) {
      return true;
    } else if (navigator.vendor === null || navigator.vendor !== null) {
      return false;
    }
  }

  async componentDidMount() {

    //---- Video handler
		/*const VideoAudio = EventEmitter.addListener(`/clubbers/meta`, async data => {
			
		}); this.setState({VideoAudio});*/


		//await this.playVideo();
		if( this.state.autoPlay ) this.playVideo();
    
    //document.querySelector('video').setAttribute('oncontextmenu', "return false;")
  }

  componentWillUnmount() {
    //this.setState({status: 0});
    //if( this.player ) this.player.destroy();
    //clearTimeout(this.retry);
    //if( this.state.VideoAudio ) this.state.VideoAudio.remove();
		clearTimeout(this.retry);
  }

	ref = player => {
    this.player = player
  }


  

	async load() {

    let url = this.state.url;
    let resolution = {};
    let resolutions = [];
    let locations = this.state.locations;
    if( this.state.service ) {
      const user = this.context;
      let video = this.state.video;
      let source = this.state.source;
      let params = new URLSearchParams();
      params.append("service", this.state.service);
      params.append("uid", user.user.user.id);
      if( source.selected !== 0 ) params.append('source', this.state.resolutions[source.selected].height);
      if( locations.selected !== -1 ) params.append("server", this.state.locations.servers[locations.selected].id);
      const x = await putApi('/v3/server/video', params);
      if( x.status === 200 ) {
        url = x.data.stream;
        resolution = x.data.resolution || {};
        resolutions = x.data.resolutions || [];
        locations.servers = x.data.servers || [];
        //this.setState({url: x.data.stream, servers: x.data.servers});
      }
    }
    this.setState({url, resolution, resolutions, locations});
    
    


    /*if( x.status === 200 && Object.keys(x.data).length === 2 ) {
      this.setState({url: x.data.stream, servers: x.data.servers});
    } else {
      setTimeout(()=>{
        this.load(url);
      }, 1000);
    }*/

    /*this.setState({url: x.data.stream});
    //if( user.user?.admin?.part_admin_access ) {
      if( x.data.servers ) {
        this.setState({servers: x.data.servers});
      }
    //}*/
  }

	playVideo() {
		//const url = this.state.url;
    let muted = this.state.muted;
    if( this.iOSversion() ) muted = true;
    this.setState({
			playing: true, muted
    }, async () => await this.load());
	}
	handlePause = () => {
		this.setState({playing: false});
    clearTimeout(this.retry);
	}
	async retryVideo() {
		clearTimeout(this.retry);
		this.playVideo();
	}


  showControls() {
    let controls = this.state.controls;
    controls.visible = true;
    this.setState({controls});
    clearTimeout(this.clearcontrols);
  }

  hideControls() {
    this.clearcontrols = setTimeout(()=>{
      let controls = this.state.controls;
      controls.visible = false;
      this.setState({controls, settings: false, cdn: false});
    },4000);
  }

  showVolume() {
    this.setState({volumeshow: true});
    clearTimeout(this.clearvolume);
  }

  hideVolume() {
    this.clearvolume = setTimeout(()=>{
      this.setState({volumeshow: false});
    },4000);
  }

  muteVolume() {
    /*if( this.state.mute ) {
    } else {
    }
    this.player.muted = !this.state.mute;*/
    this.setState({muted: !this.state.muted});
  }

  setVolume(event) {
    try{
      let percent = 1-((event.clientY - event.target.getBoundingClientRect().top) / event.target.getBoundingClientRect().height);
      this.player.volume = Number(percent).toFixed(1);
      this.setState({volume: percent});
      if( this.state.muted ) this.muteVolume();
		} catch(error){}
  }

  fullscreen() {
    screenfull.request(this.player);
  }

  settings() {
    let source = this.state.source;
    source.show = !source.show;
    this.setState({source});
  }

  cdn() {
    let locations = this.state.locations;
    locations.show = !locations.show;
    this.setState({locations});
  }

  selectStream(stream) {
    let source = this.state.source;
    if( source.selected === stream ) return;
    source.selected = stream;
    this.setState({source},()=>{
      this.load();
    });
  }

  selectServer(server) {
    let locations = this.state.locations;
    if( locations.selected === server ) return;
    locations.selected = server;
    this.setState({locations},()=>{
      this.load();
    });
    /*let video = this.state.video;
    video.server = id;
    this.setState({video}, ()=>{
      this.playVideo(id);
    })*/
  }

  videoHelp() {
    this.setState({showHelp: !this.state.showHelp});
  }

  async progress(event) {
    let position = await this.convertTime(event.playedSeconds);
    let duration = await this.convertTime(event.loadedSeconds);
    let percent = Math.floor(event.playedSeconds / event.loadedSeconds * 100);
    if( percent > 100 ) percent = 100;
    this.setState({time: {position, duration, percent}});
  }

  async convertTime(time) {
		let duration = Math.ceil(time);
		let mins = ~~((duration) / 60);
		let secs = ~~duration % 60;
		return `${mins.toString().padStart(2,"0")}:${secs.toString().padStart(2,"0")}`;
	}

  async position(event) {
		try {
			let percent = (event.clientX - event.target.getBoundingClientRect().left) / event.target.getBoundingClientRect().width;
      

      
      this.player.seekTo(percent);
      //let time = Math.floor(percent*this.ref.getDuration());
      

			/*let audio = document.getElementById("audioplayer");
			let time = Math.floor(percent*audio.duration);
			audio.currentTime = time;*/
		} catch(error) {
      consoleLog(error);
		}
	}

  async mute() {
		try {
			let volume = this.state.volume;
      //consoleLog(volume);
      volume.muted = !volume.muted;
      //this.player.
      this.setState({volume});
		} catch(error) {
			
		}
	}

	handlePlay = () => {
		this.setState({playing: true});
	}
	
	handleError = (e) => {
		
		if( e.toString().indexOf('play') > 0 ) {
			this.setState({playing: false});
		} else {
			this.props.onError();
			this.retry = setTimeout(()=>{this.retryVideo();},5000);
		}
  }

	

  render() {
    //consoleLog(this.props.customUrl?this.props.customUrl[0]:this.state.url);
    const show_source =
      <div className="video-settings">
        <ul style={{color: '#ffffff'}}>
          <li>Video Source</li>
          {this.state.resolutions.map((e,i) => {
			      return (
              <li key={i} onClick={()=>this.selectStream(i)}>{e.height}p
                {i === this.state.source.selected &&<span className="quality-tick">&#10004;</span>}
              </li>
            )
          })}
        </ul>
      </div>;
    const show_servers =
      <div className="video-servers">
        <ul>
          {this.state.locations.servers.map((e,i) => {
			      return (
              <li key={i} onClick={()=>this.selectServer(i)}>{e.location}
                {i === this.state.locations.selected &&
                  <span className="quality-tick">&#10004;</span>
                }
              </li>
            )
          })}
        </ul>
      </div>;
    return (
      
      <div className="video-panel" onMouseEnter={this.showControls} onMouseLeave={this.hideControls}>
        {this.state.service === undefined && this.state.url === undefined ?
          <>
            Missing video input: service || url
          </>
        :
          <>
            <div id="video-container" className="video-js-box">
              <ReactPlayer
                ref={this.ref}
                url={this.props.customUrl?this.props.customUrl.replaceAll(' ','%20'):this.state.url}
                playing={this.state.playing}
                onPause={this.handlePause}
                volume={this.state.volume.volume}
                muted={/*this.props.customUrl?true:*/this.state.volume.muted}
                loop={/*this.props.customUrl?true:*/false}
                progressInterval={500}
                onProgress={this.progress}
                onPlay={this.handlePlay}
                onError={this.handleError}
                onEnded={this.props.onError}
                //onBufferEnd={this.handleError}
                width="1280"
                height="720"
                config={{
                  attributes: { /*poster: this.props.uid>0?`https://mix365.co.uk/images/live/${this.props.uid}.png`:"https://mix365.co.uk/images/video_now_loading.gif"*/ },
                  playsinline: true,
                  file: {
                    attributes: {
                      crossOrigin: "use-credentials",
                    }
                  }
                }}
                playsinline={true}
                
              />
            </div>

            {this.state.service ?
              <>
                {this.state.source.show && <>{show_source}</>}
                {this.state.locations.show && <>{show_servers}</>}

                <div className="video-buttons-panel">

                  <ul className="video-buttons-right">
                    {this.state.resolution.height &&
                      <li className="video-resolution" style={{cursor: 'default', color: '#ffffff'}}>
                        {this.state.resolution?.height}p
                      </li>
                    }
                    <li>
                      <OverlayTrigger
                        
                        placement="top"
                        overlay={<Tooltip id="button-tooltip-2">Video Source</Tooltip>}
                        >
                        <svg onClick={this.settings}><Settings /></svg>
                      </OverlayTrigger>
                    </li>
                    {//user.user?.admin?.part_admin_access === true &&
                      <li>
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip id="button-tooltip-2">Server Locations</Tooltip>}
                          >
                          <svg onClick={this.cdn}><CDN /></svg>
                        </OverlayTrigger>
                      </li>
                    }
                    <li className="hidden">
                      <OverlayTrigger
                        className="d-none d-lg-block"
                        placement="top"
                        overlay={<Tooltip id="button-tooltip-2">Theatre Mode</Tooltip>}
                        >
                        <svg onClick={this.props.theatre}><TheatreOnButton /></svg>
                      </OverlayTrigger>
                    </li>
                    <li>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="button-tooltip-2">Fullscreen</Tooltip>}
                        >
                        <svg onClick={this.fullscreen}><FullscreenOnButton /></svg>
                      </OverlayTrigger>
                    </li>
                    
                    {/*<li>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="button-tooltip-2">Video Help</Tooltip>}
                        >
                        
                        <FontAwesomeIcon icon="triangle-exclamation" className="video-warning" onClick={this.videoHelp} />
                        
                      </OverlayTrigger>
                    </li>*/}
                    
                  </ul>
                  <ul className="video-buttons-left">
                    
                    {this.state.playing ?
                      <li onClick={()=>this.handlePause()}><svg><StopButton /></svg></li>
                    :
                      <li onClick={()=>this.playVideo()}><svg><PlayButton /></svg></li>
                    }
                    
                    <li onMouseEnter={this.showVolume} onMouseLeave={this.hideVolume} style={{position:'relative'}}>
                      {(this.state.volumeshow || this.state.muted) &&
                        <div style={{position: 'absolute', backgroundColor: '#6b0731', width: 8, height: 60, left: 14, bottom: 40, borderRadius: 4, animation: 'second_animateIt 1s linear'}}>
                          <div style={{position: 'absolute', bottom: 0, backgroundColor: '#ffffff',width: 8, height: (this.state.muted?0:this.state.volume*60), borderRadius: 4}}></div>
                          <div style={{position: 'absolute', bottom: (this.state.muted?0:this.state.volume*60-4), backgroundColor: '#ffffff',width: 14, height: 8, left:-3, borderRadius: 8}}></div>
                          <div style={{position: 'relative', width: '100%', height: '100%'}} onClick={this.setVolume}></div>
                        </div>
                      }
                      {this.state.muted ?
                        <svg onClick={this.muteVolume}><VolumeButton0 /></svg>
                      :
                        <>
                          {this.state.volume > 80 ?
                            <svg onClick={this.muteVolume}><VolumeButton100 /></svg>
                          :
                          <svg onClick={this.muteVolume}><VolumeButton50 /></svg>
                          }
                        </>
                      }
                      
                    </li>
                  </ul>

                </div>
              </>
            :
              <>
                {this.state.controls.show === true && (this.state.controls.visible === true || this.state.playing === false) &&
                  <div className="video-buttons-panel">
                    <div style={{position: 'relative', width: '100%', height: '2.5em', fontSize: '.813rem'}}>
                    <div className={`audioplayer ${this.state.playing===true&&'audioplayer-playing'} ${this.state.volume.muted===true&&'audioplayer-mute'}`}>
                      
                      <div className="audioplayer-playpause" title="Pause" onClick={()=>this.state.playing===true?this.handlePause():this.playVideo()}>
                        <span>Pause</span>
                      </div>
                      <div className="audioplayer-time audioplayer-time-current">{this.state.time.position}</div>
                      <div className="audioplayer-bar">
                        <div className="audioplayer-bar-loaded" style={{width: '100%'}}></div>
                        <div className="audioplayer-bar-played" style={{width: `${this.state.time.percent}%`}}></div>
                        <div className="audioplayer-bar-overlay" onClick={(e)=>this.position(e)} style={{width: '100%', zIndex: 100}}></div>
                      </div>
                      <div className="audioplayer-time audioplayer-time-duration">{this.state.time.duration}</div>
                      <div className="audioplayer-volume">
                        <div className="audioplayer-volume-button" title="Volume" onClick={()=>this.mute()}><span>Volume</span></div>
                        {/*<div className="audioplayer-volume-adjust">
                          <div>
                            <div style={{height: '100%'}}></div>
                          </div>
                        </div>*/}
                      </div>
                    </div>
                  </div>
                  </div>
                }
              </>
            }


          </>
        }
        {/*}
        <div id="video-container" className="video-js-box">
          
					

          {/*<video id={this.state.id}
            playsInline
            poster={(this.state.status===0&&this.props.uid>0)?`https://mix365.co.uk/images/live/${this.props.uid}.png`:"https://mix365.co.uk/images/video_now_loading.gif"}
            ref={player => (this.player = player)}
            //autoPlay={true}
            width="100%"
            controls={false}
					/>*}
          {!this.state.playing &&
            <span className="playButton" onClick={()=>this.playVideo()}>
              <svg><PlayButton /></svg>
            </span>
          }
          {/*this.state.playing &&
            <span className="loadingButton">
              <svg><LoadingButton /></svg>
            </span>
					*}
        </div>
        
        {/*this.props.customUrl
        this.props.controls*}

        {this.props.controls && (this.state.controls || this.state.muted) &&
          <>
            <div className="video-buttons-panel">
              
              
            </div>
          </>
        }*/}
        
      </div>
    )
  }
}

export default VideoPlayer;
